<script setup lang="ts">
definePageMeta({
  layout: 'site',
  title: 'pages.index.title',
  description: 'pages.index.description',
})

const triggerError = () => {
  throw new Error('Nuxt Button Error')
}
</script>

<template>
  <button id="errorBtn" @click="triggerError">Trigger Error</button>
</template>
